import React, { Component } from 'react';
import Page from '../../containers/page';

import {
  Container,
  Row,
  Col,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from 'reactstrap';

import Isvg from 'react-inlinesvg';

import Search from '../../components/search';
import { Link } from 'react-router-dom';

import ListBuilder from '../../components/listBuilder';
import DeleteModal from '../../components/deleteModal';
import {
  getSearchParams,
  generateSearchLink,
  generateSearchLinkMultiple,
} from '../../helpers/linkHelper';
import { API_ENDPOINT } from '../../constants';

import garabageIcon from '../../assets/svg/garabage.svg';
import userIcon from '../../assets/svg/user-icon.svg';
import notification from '../../assets/svg/notification.svg';
import profile from '../../assets/svg/profile-image.svg';
import moreIcon from '../../assets/svg/more.svg';
import map from '../../assets/svg/map.svg';
import chart from '../../assets/svg/chart.svg';
import editIcon from '../../assets/svg/edit.svg';
import moment from 'moment';

class List extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ...props.initialData,
      form: false,
      useState: false,
      params: {
        entries: 10,
        page: 0,
      },
      items: [],
      areas: [],
      total: 0,
      loading: true,
      newsData: [],
    };
  }

  get = () => {
    for (let i = 0; i < this.props.loadData.length; i++) {
      this.props.loadData[i](
        window.fetch,
        this.props.lang,
        this.props[0].match,
        this.state.useState
          ? this.state.params
          : getSearchParams(this.props[0].location.search, {
              entries: 10,
              page: 0,
            }),
      ).then((data) => {
        this.setState(
          {
            ...data,
            loading: null,
          },
          () => {
            this.props.updateMeta(
              this.props.generateSeoTags(this.state, this.props.lang),
            );
          },
        );
      });
    }

    for (let i = 0; i < this.props.loadDataWithQuery.length; i++) {
      this.props.loadDataWithQuery[i](
        window.fetch,
        this.props.lang,
        this.props[0].match,
        this.state.useState
          ? this.state.params
          : getSearchParams(this.props[0].location.search, {
              entries: 10,
              page: 0,
            }),
      ).then((data) => {
        this.setState(
          {
            ...data,
            loading: null,
          },
          () => {
            this.props.updateMeta(
              this.props.generateSeoTags(this.state, this.props.lang),
            );
          },
        );
      });
    }
  };

  componentDidMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0);
    }

    this.get();
  }

  componentDidUpdate(prevProps) {
    if (prevProps[0].location.search != this.props[0].location.search) {
      this.setState(
        {
          loading: true,
        },
        () => {
          this.get();
        },
      );
    }
  }

  updateSort = (field, type) => {
    if (this.state.useState) {
      let state = this.state.params;
      state.sortField = field;
      state.sortType = type;
      this.setState({
        params: state,
      });
    } else {
      this.props[0].history.push(
        generateSearchLinkMultiple(
          this.props[0].location.search,
          { entries: 10, page: 0 },
          [
            { name: 'sortField', value: field },
            { name: 'sortType', value: type },
          ],
          false,
        ),
      );
    }
  };

  updateParams = (name, value, restart = false) => {
    if (name === 'filter') {
      const marko = this.props.uData._id === '6507e98d1baf6373b920aa34';

      if (
        this.props.uData &&
        (this.props.uData._id === '603e55228b8e6e6cebc33f04' ||
          this.props.uData._id === '603e55108b8e6e6cebc33f03' ||
          marko)
      ) {
      } else {
        return;
      }
    }
    if (this.state.useState) {
      if (restart) {
        let obj = {
          entries: 10,
          page: 0,
        };
        obj[name] = value;
        this.setState({ params: obj });
      } else {
        let obj = this.state.params;
        obj[name] = value;
        this.setState({ params: obj });
      }
    } else {
      this.props[0].history.push(
        generateSearchLink(
          this.props[0].location.search,
          { entries: 10, page: 0 },
          name,
          value,
          restart,
        ),
      );
    }
  };

  updateMultipleParams = (fields, restart = false) => {
    if (this.state.useState) {
      if (restart) {
        let obj = {
          entries: 10,
          page: 0,
        };
        for (let i = 0; i < fields.length; i++) {
          obj[fields[i].name] = fields[i].value;
        }
        this.setState({ params: obj });
      } else {
        let obj = this.state.params;
        for (let i = 0; i < fields.length; i++) {
          obj[fields[i].name] = fields[i].value;
        }
        this.setState({ params: obj });
      }
    } else {
      this.props[0].history.push(
        generateSearchLinkMultiple(
          this.props[0].location.search,
          { entries: 10, page: 0 },
          fields,
          restart,
        ),
      );
    }
  };

  delete = (id) => {
    this.setState(
      {
        loading: true,
      },
      () => {
        fetch(API_ENDPOINT + '/data/shop/orders/' + id, {
          method: 'DELETE',
          headers: {
            'content-type': 'application/json',
            Authorization:
              typeof localStorage !== 'undefined'
                ? `Bearer ${localStorage.getItem('authToken')}`
                : null,
          },
        })
          .then((res) => res.json())
          .then((result) => {
            this.get();
          });
      },
    );
  };
  formatStatus = (status) => {
    let returnValue;
    if (status === 'waiting') {
      returnValue = <div style={{ color: 'orange' }}>{'NA ČEKANJU'}</div>;
    } else if (status === 'rejected') {
      returnValue = <div style={{ color: 'red' }}>{'ODBIJENO'}</div>;
    } else if (status === 'approved') {
      returnValue = <div style={{ color: 'green' }}>{'ODOBRENO'}</div>;
    }

    return returnValue;
  };

  approveOrder = () => {
    if (this.state.actionModal && this.state.actionModal._id) {
      fetch(
        API_ENDPOINT +
          '/data/shop/orders/approve/' +
          this.state.actionModal._id,
        {
          method: 'POST',
          headers: {
            'content-type': 'application/json',
            Authorization:
              typeof localStorage !== 'undefined'
                ? `Bearer ${localStorage.getItem('authToken')}`
                : null,
          },
        },
      )
        .then((response) => {
          return response.json().then((json) => {
            return {
              result: json,
              status: response.status,
            };
          });
        })
        .then(({ result, status }) => {
          if (status >= 200 && status < 300) {
            this.setState({ actionModal: null });
            this.get();
          } else {
            this.setState({
              errorModal: true,
              actionModal: null,
              errorMessage:
                result.message ||
                result.error ||
                'Nepoznata greška prilikom potvrde narudžbine',
            });
          }
        });
    }
  };

  rejectOrder = () => {
    if (this.state.actionModal && this.state.actionModal._id) {
      fetch(
        API_ENDPOINT + '/data/shop/orders/reject/' + this.state.actionModal._id,
        {
          method: 'POST',
          headers: {
            'content-type': 'application/json',
            Authorization:
              typeof localStorage !== 'undefined'
                ? `Bearer ${localStorage.getItem('authToken')}`
                : null,
          },
        },
      )
        .then((res) => res.json())
        .then((result) => {
          this.setState({ actionModal: null });

          this.get();
        });
    }
  };

  render() {
    let params = {};
    if (this.state.useState) {
      params = this.state.params;
    } else {
      params = getSearchParams(this.props[0].location.search, {
        entries: 10,
        page: 0,
      });
    }

    return (
      <div className='page'>
        <Container className='dashboard'>
          <Row>
            <Col lg='12'>
              <Search updateParams={this.updateParams} />
              <div className='panel'>
                <div className='main-table-header'>
                  <h5 className='component-header'>Lista</h5>
                </div>

                <ListBuilder
                  loading={this.state.loading && false}
                  total={this.state.total}
                  showNumeration={false}
                  fields={[
                    {
                      type: 'text',
                      class: 'labelbam',
                      name: 'articleName',
                      sortLabel: 'Po imenu',
                      allowSort: true,
                    },
                    {
                      type: 'text',
                      class: 'labelbam',
                      name: 'userName',
                      sortLabel: 'Po imenu',
                      allowSort: true,
                    },
                    {
                      type: 'text',
                      class: 'labelbam',
                      name: 'status',
                      sortLabel: 'Po imenu',
                      allowSort: true,
                    },
                    {
                      type: 'text',
                      class: 'labelbam',
                      name: 'time',
                      sortLabel: 'Po imenu',
                      allowSort: true,
                    },
                  ]}
                  rawItems={this.state.items}
                  items={this.state.items.map((item, idx) => {
                    return {
                      ...item,
                      articleName:
                        item.article && item.article.name
                          ? item.article.name
                          : null,
                      userName:
                        item.user && item.user.firstName && item.user.lastName
                          ? `${item.user.firstName} ${item.user.lastName}`
                          : null,
                      time: item.timestamp
                        ? moment
                            .unix(item.timestamp)
                            .format('DD.MM.YYYY HH:mm:ss')
                        : null,
                      status: this.formatStatus(item.status),
                    };
                  })}
                  actions={[
                    {
                      component: (
                        <Isvg
                          src={editIcon}
                          className='edit-icon'
                        />
                      ),
                      onClick: (item) => this.setState({ actionModal: item }),
                    },
                    {
                      component: (
                        <Isvg
                          src={garabageIcon}
                          className='edit-icon'
                        />
                      ),
                      onClick: (item) => this.setState({ deleteModal: item }),
                    },
                  ]}
                  params={params}
                  sortField={params.sortField}
                  sortType={params.sortType}
                  updateSort={this.updateSort}
                  updateParams={this.updateParams}
                  updateMultipleParams={this.updateMultipleParams}
                ></ListBuilder>

                <DeleteModal
                  isOpen={this.state.deleteModal}
                  toggle={() => this.setState({ deleteModal: null })}
                  handler={() => {
                    this.delete(this.state.deleteModal._id);
                    this.setState({ deleteModal: null });
                  }}
                >
                  Obrisi{' '}
                  <strong>
                    {this.state.deleteModal && this.state.deleteModal.name}
                  </strong>
                  ?
                </DeleteModal>
                {this.state.errorModal ? (
                  <Modal
                    isOpen={this.state.errorModal}
                    toggle={() => {
                      this.setState({ errorModal: null });
                    }}
                    className='order-modal-wrap'
                  >
                    <ModalHeader>
                      <span className='danger-color'>Greška</span>
                    </ModalHeader>
                    <ModalBody className='delete-modal'>
                      <div className='mb-3'>
                        Dogodila se greška : {this.state.errorMessage}
                      </div>
                    </ModalBody>
                    <ModalFooter>
                      <Button
                        color='primary'
                        onClick={() =>
                          this.setState({
                            errorModal: null,
                            errorMessage: null,
                          })
                        }
                      >
                        {'ZATVORI'.translate(this.props.lang)}
                      </Button>{' '}
                    </ModalFooter>
                  </Modal>
                ) : null}
                {this.state.actionModal ? (
                  <Modal
                    isOpen={this.state.actionModal}
                    toggle={() => {
                      this.setState({ actionModal: null });
                    }}
                    className='order-modal-wrap'
                  >
                    <ModalHeader>Narudzba</ModalHeader>
                    <ModalBody className='delete-modal'>
                      <div className='order-modal-body'>
                        <div className='order-article-info'>
                          {this.state.actionModal.article ? (
                            <>
                              <h4>Artikal:</h4>
                              {this.state.actionModal.article.images &&
                              this.state.actionModal.article.images[0] ? (
                                <img
                                  src={`${API_ENDPOINT}${this.state.actionModal.article.images[0]}`}
                                />
                              ) : null}
                              <h5>
                                Artikal:{' '}
                                <span>
                                  {this.state.actionModal.article.name}
                                </span>
                              </h5>
                              {this.state.actionModal.article
                                .shortDescription ? (
                                <h5>
                                  Kratki opis:{' '}
                                  <span>
                                    {
                                      this.state.actionModal.article
                                        .shortDescription
                                    }
                                  </span>{' '}
                                </h5>
                              ) : (
                                <></>
                              )}
                              {this.state.actionModal.article.externalId ? (
                                <h5>
                                  Externi ID:{' '}
                                  <span>
                                    {this.state.actionModal.article.externalId}
                                  </span>{' '}
                                </h5>
                              ) : (
                                <></>
                              )}
                              <h5>
                                Cijena:{' '}
                                <span>
                                  {this.props.formatPrice(
                                    this.state.actionModal.article.price,
                                  )}
                                </span>
                              </h5>
                            </>
                          ) : null}
                        </div>
                        <div className='user-article-info'>
                          {this.state.actionModal.user ? (
                            <>
                              <h4>Korisnik:</h4>
                              <h5>
                                {this.state.actionModal.user.firstName}{' '}
                                {this.state.actionModal.user.lastName}
                              </h5>
                              <h5>{this.state.actionModal.user.workPlace}</h5>
                              <h5>{this.state.actionModal.user.workUnit}</h5>
                              <h5>{this.state.actionModal.user.sector}</h5>
                            </>
                          ) : null}
                        </div>
                      </div>
                      <div className='order-date'>
                        <div>
                          Zahtjev poslat:{' '}
                          {moment
                            .unix(this.state.actionModal.timestamp)
                            .format('DD.MM.YYYY HH:mm')}
                        </div>
                        {this.state.actionModal.rejectedTs ? (
                          <div>
                            {' '}
                            Zahtjev odbijen:{' '}
                            {moment
                              .unix(this.state.actionModal.rejectedTs)
                              .format('DD.MM.YYYY HH:mm')}
                          </div>
                        ) : null}
                        {this.state.actionModal.approvedTs ? (
                          <div>
                            {' '}
                            Zahtjev odobren:{' '}
                            {moment
                              .unix(this.state.actionModal.approvedTs)
                              .format('DD.MM.YYYY HH:mm')}
                          </div>
                        ) : null}
                      </div>
                    </ModalBody>
                    <ModalFooter>
                      <Button
                        color='primary'
                        onClick={() => this.setState({ actionModal: null })}
                      >
                        {'ODUSTANI'.translate(this.props.lang)}
                      </Button>{' '}
                      {!this.state.actionModal.finished ? (
                        <>
                          <Button
                            color='danger'
                            onClick={() => this.approveOrder()}
                          >
                            {'ODOBRI'.translate(this.props.lang)}
                          </Button>{' '}
                          <Button
                            color='danger'
                            onClick={() => this.rejectOrder()}
                          >
                            {'ODBIJ'.translate(this.props.lang)}
                          </Button>{' '}
                        </>
                      ) : null}
                    </ModalFooter>
                  </Modal>
                ) : null}
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default Page(List);
